import { SentimentLineWidget } from "./SentimentLineWidget";
import { SentimentPieWidget } from "./SentimentPieWidget";

const SentimentWidget = (props) => {
  const moreProps = { ...props, showIsProcessingInfo: true };

  return props.chartType == "pie" ? (
    <SentimentPieWidget {...moreProps} />
  ) : (
    <SentimentLineWidget {...moreProps} />
  );
};

export { SentimentWidget };
